module.exports = __webpack_public_path__ + "img/bg.ee5b2787.png";